import './LoadAllModal.scss';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Error from '../../../../common/Error/Error';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';

// General LoadAllModal Component
const LoadAllModal = ({
  movementType,
  category,
  movement,
  assignment,
  setModalOpen,
  refreshPackages,
  packages,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const loadAll = () => {
    setLoading(true);
    GoodsOut.assign(
      category,
      movement.id,
      packages.map(pkg => pkg.id),
    )
      .then(() => {
        setLoading(false);
        refreshPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const unloadAll = () => {
    setLoading(true);
    const expectedNumber = assignment?.quantity;
    GoodsIn.updatePackageCount(category, movement.id, assignment?.job?.id, expectedNumber)
      .then(() => {
        setLoading(false);
        refreshPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="load_all_movement_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">
        {movementType == 'collections' || movementType == 'imports'
          ? 'Unload the expected number of packages?'
          : 'Load all packages currently in the warehouse?'}
      </div>
      <div className="load_all_movement_buttons">
        <button className="load_all_button" onClick={() => setModalOpen(false)}>
          Cancel
        </button>
        <button
          className="ok_button"
          onClick={
            movementType == 'collections' || movementType == 'imports'
              ? () => unloadAll()
              : () => loadAll()
          }
        >
          OK
        </button>
      </div>
    </div>
  );
};

LoadAllModal.propTypes = {
  movementType: PropTypes.string,
  category: PropTypes.string,
  movement: PropTypes.object,
  assignment: PropTypes.object,
  setModalOpen: PropTypes.func,
  refreshPackages: PropTypes.func,
  packages: PropTypes.array,
};

export default LoadAllModal;
